import * as types from '../mutation-types'
import axios from "axios";

// state
export const state = {
    filters: {},
    filters_data: {},
    filters_salon: {},
    filters_salon_data: {},
    selected: [],
};

// getters
export const getters = {
    filters: state => state.filters,
    filters_data: state => state.filters_data,
    filters_salon: state => state.filters_salon,
    filters_salon_data: state => state.filters_salon_data,
    selected: state => state.selected,
};

// mutations
export const mutations = {
    [types.REQUESTS_FILTER_SET] (state, data) {
        state.filters = data;
    },
    [types.REQUESTS_FILTER_DATA_SET] (state, data) {
        state.filters_data = data;
    },
    [types.REQUESTS_FILTER_SALON_SET] (state, data) {
        state.filters_salon = data;
    },
    [types.REQUESTS_FILTER_SALON_DATA_SET] (state, data) {
        state.filters_salon_data = data;
    },
    [types.REQUESTS_SELECTED_PUSH] (state, data) {
        if (typeof data === 'object' && Array.isArray(data)) {
            state.selected.push(...data);
        } else {
            state.selected.push(data);
        }
        state.selected = _.uniq(state.selected);
    },
    [types.REQUESTS_SELECTED_PULL] (state, data) {
        if (typeof data === 'object' && Array.isArray(data)) {
            state.selected = _.without(_.clone(state.selected), ...data);
        } else {
            state.selected = _.without(_.clone(state.selected), data);
        }
    }
};

// actions
export const actions = {
    filterSet(context, data) {
        context.commit(types.REQUESTS_FILTER_SET, data);
    },
    filterDataSet(context, data) {
        context.commit(types.REQUESTS_FILTER_DATA_SET, data);
    },
    filterSalonSet(context, data) {
        context.commit(types.REQUESTS_FILTER_SALON_SET, data);
    },
    filterSalonDataSet(context, data) {
        context.commit(types.REQUESTS_FILTER_SALON_DATA_SET, data);
    },

    selectedPush(context, data) {
        context.commit(types.REQUESTS_SELECTED_PUSH, data);
    },
    selectedPull(context, data) {
        context.commit(types.REQUESTS_SELECTED_PULL, data);
    }
};
